import {
  PORTAL_APPEARANCE_ACCENT_QUERY,
  PORTAL_APPEARANCE_THEME_QUERY,
} from '../constants/appearanceQueryConstants';
import type { BrandAccentId } from '../constants/brandAccentConstants';
import type { ThemeModeId } from '../constants/themeConstants';
import { readBrandAccentFromStorage, readThemeFromStorage } from '../constants/storageKeyConstants';

/**
 * Appends current portal theme/accent from localStorage so the target app can apply them
 * on first paint. Safe no-op if storage is unavailable or values are unset.
 */
export function mergePortalAppearanceIntoUrl(urlWithoutHash: string): string {
  let theme: ThemeModeId | undefined;
  let accent: BrandAccentId | undefined;
  try {
    theme = readThemeFromStorage() ?? undefined;
    accent = readBrandAccentFromStorage() ?? undefined;
  } catch {
    /* ignore */
  }
  if (!theme && !accent) return urlWithoutHash;
  try {
    const u = new URL(urlWithoutHash);
    if (theme) u.searchParams.set(PORTAL_APPEARANCE_THEME_QUERY, theme);
    if (accent) u.searchParams.set(PORTAL_APPEARANCE_ACCENT_QUERY, accent);
    return u.toString();
  } catch {
    return urlWithoutHash;
  }
}
